export default __webpack_public_path__ + "static/media/maternidad4_c.7fb1cfb9.jpg";